import { Routes, Route, BrowserRouter } from 'react-router-dom';
import React from 'react';
import './App.css';
import AuthorizePage from './pages/Authorize';
import SignupPage from './pages/Signup';
import ResetPasswordRequestPage from './pages/ResetPasswordRequest';
import ResetPasswordPage from './pages/ResetPassword';
import VerifyEmailPage from './pages/VerifyEmail';
import { getThemeBasedOnDomain } from './lib/helpers';

export interface AppProps {
  env: string;
}

function App({ env }: AppProps) {
  if (env === 'development') {
    console.log('Booting app in development mode');
  }

  document.title = getThemeBasedOnDomain().name;
  return (
    <div className="min-h-full w-full flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
      <BrowserRouter>
        <Routes>
          <Route path="/oauth/authorize" element={<AuthorizePage />}></Route>
          <Route path="/signup" element={<SignupPage />}></Route>
          <Route
            path="/reset/password"
            element={<ResetPasswordRequestPage />}
          ></Route>
          <Route
            path="/reset/password/confirm"
            element={<ResetPasswordPage />}
          ></Route>
          <Route path="/verify" element={<VerifyEmailPage />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
